<template>
  <div>
    <base-header class="pb-8 pt-4" />
    <div class="container-fluid mt--7">
      <b-card no-body>
        <b-card-header>
          <div class="align-items-center row">
            <div class="col">
              <h3 class="card-title mb-0">{{ $t("Randevular") }}</h3>
            </div>
            <div class="col" >
              <b-form-group class="mb-0">
                <b-form-select v-model="company" :options="companies" @change="cPage=1; refreshTable();"/>
              </b-form-group>
            </div>
            <div class="col text-right">
<!--              <b-button :to="{name: 'create-client'}" variant="primary">+ Yeni Ekle</b-button>-->
            </div>
          </div>
        </b-card-header>

        <b-table ref="table" class="align-items-center" thead-class="thead-light" :fields="fields" :items="loadData" show-empty>

          <template v-slot:table-busy>
            <div style="width: 100%; text-align:center;">
              <b-spinner label="Spinning"></b-spinner>
            </div>
          </template>

          <template v-slot:empty>
            <b-alert variant="warning" show>{{ $t("Henüz hiç randevu oluşturmamışsınız, hemen yeni bir tane ekleyin!") }}</b-alert>
          </template>

          <template v-slot:cell(client_name)="data">
            {{ data.item.client ? data.item.client.full_name : 'Müşteri Silinmiş' }}
          </template>

          <template v-slot:cell(client_gsm)="data">
            {{ data.item.client ? data.item.client.gsm : 'Müşteri Silinmiş' }}
          </template>

          <template v-slot:cell(datetime)="data">
            {{ moment(data.item.start).format('D.MM.Y HH:mm') }} - {{ moment(data.item.end).format('HH:mm') }}
          </template>

          <template v-slot:cell(actions)="data">
            <b-button size="sm" v-if="data.item.client" variant="outline-warning" @click="openReminderModal(data.item)">
              {{ $t("SMS ile Hatırlat") }}</b-button>
            <b-button size="sm" variant="dark" @click="edit(data.item.id)">{{ $t("Düzenle") }}</b-button>
            <b-button size="sm" variant="info" @click="setPassiveAction(data.item.id)">{{ $t("Tamamla") }}</b-button>
            <b-button size="sm" variant="danger" @click="deleteAction(data.item.id)">{{ $t("Sil") }}</b-button>
          </template>

        </b-table>

        <div class="w-100 d-flex align-items-center justify-content-center mt-2 mb-3" v-if="pagination.totalRows > 14">
          <b-pagination v-model="pagination.currentPage" :total-rows="pagination.totalRows" :per-page="pagination.perPage" />
        </div>
      </b-card>
    </div>

    <b-modal title="Randevu Hatırlat" ref="reminderModal">
      <b-form-group>
        <label>{{ $t("Mesaj") }}</label>
        <b-form-textarea rows="5" v-model="reminder.text" />
      </b-form-group>

      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="$refs.reminderModal.hide()">{{ $t("Kapat") }}</b-button>
        <b-button variant="primary" @click="remindAppointment">{{ $t("SMS Gönder") }}</b-button>
      </template>
    </b-modal>


    <b-modal ref="modal" title="Randevu Kaydı" @hide="resetCalendarModal">
      <b-form-group>
        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t('Müşteri Seçimi') }} <span
            style="color:red">*</span></legend>
        <v-select v-model="calendarModal.client" :options="clients" @input="checkClient"></v-select>
      </b-form-group>

      <b-form-group label="Ürün / Hizmet Seçimi">
        <ul v-if="calendarModal.services.length" style="margin-bottom:10px;padding-left:20px;padding-bottom:0;">
          <li v-for="(service, key) in calendarModal.services" :key="key" style="font-size:14px;margin-bottom:4px;">
            <a href="#" @click.prevent="removeService(key)">(x)</a> {{ service.label }}
          </li>
        </ul>
        <v-select v-model="service" :options="services" @input="checkService"></v-select>
      </b-form-group>

      <b-row>
        <b-col sm="8">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t('Başlangıç Tarihi') }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.start_date" type="date"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t('Başlangıç Saati') }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.start_time" type="time"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="8">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t('Bitiş Tarihi') }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.end_date" type="date"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">{{ $t('Bitiş Saati') }} <span
                style="color:red">*</span></legend>
            <b-form-input v-model="calendarModal.end_time" type="time"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <!--      <b-form-group>-->
      <!--        <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">İlgili Çalışan <span style="color:red">*</span></legend>-->
      <!--        <v-select v-model="calendarModal.employee" :options="employees" />-->
      <!--      </b-form-group>-->

      <template v-slot:modal-footer>
        <div class="w-100 d-flex align-items-center justify-content-between">
          <div class="left">
            <b-form-checkbox v-model="calendarModal.sendSMS">{{ $t("Bildirim SMS'i Gönder") }}</b-form-checkbox>
          </div>
          <div class="right">
            <b-button @click="hideModal">İptal</b-button>
            <b-button variant="primary" @click="updateAppointment" class="loading-button"
                      :disabled="buttonLoading">
              <i v-if="buttonLoading" class="fa fa-spinner"></i> {{ $t('Kaydet') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
  import {required} from "vuelidate/lib/validators";
  import moment from 'moment';
import request from "../../request";

  export default {
    name: 'AppointmentList',
    computed: {
      ...mapGetters(['companies']),
      getType() {
        return this.$route.params.type
      },
      fields() {
        let fields = [
          {key: 'datetime', label: 'Tarih'},
          {key: 'client_name', label: 'Ad soyad'},
          {key: 'client_gsm', label: 'Telefon'},
          {key: 'description', label: 'Açıklama'},
        ]

        if (this.getType == 'all')
          fields.push({'company': 'Bayii'})
        else
          fields.push(
              {key: 'actions', label: '', tdClass: 'text-right'})


        return fields;

      }
    },
    data () {
      return {
        company: null,
        loading: true,
        buttonLoading: false,
        pagination: {
          currentPage: 1,
          totalRows: 1,
          perPage: 15,
        },
        calendarModal: {
          client: {},
          employee: { label: "Tüm Çalışanlar", value: "all" },
          services: [],
          start_date: null,
          start_time: null,
          end_date: null,
          end_time: null,
          sendSMS: false,
        },
        serviceModal: {
          name: "",
          price: 0,
        },
        clientModal: {
          full_name: "",
          gsm: "",
          email: ""
        },
        services: [],
        clients: [],
        employees: [],
        reminder: {
          id: '',
          text: '',
        },
      }
    },
    methods: {
      ...mapActions([
        'getAppointments',
        'createAppointment',
        'deleteAppointment',
        'createServiceVSelect',
        'createClientVSelect',
        'appointmentReminder',
        'setPassive'
      ]),
      ...mapMutations(['setSMSBalance']),
      setPassiveAction(id) {
        this.setPassive(id).then(response => {
          this.success(response.data.message);
          this.refreshTable();
        }).catch(error => {
          this.error(error.response.data.message);
        })
      },

      edit(id){
        request.get('appointments/'+id).then(res=>{
          this.calendarModal=res.data.data
          this.calendarModal.services.map(s=>{
            s.label=s.name
          });
          this.calendarModal.client=this.calendarModal.client.full_name;
          this.calendarModal.id=this.calendarModal.id
          this.calendarModal.start_date=moment(this.calendarModal.start_time).format("YYYY-MM-DD");
          this.calendarModal.end_date=moment(this.calendarModal.end_time).format("YYYY-MM-DD");
          this.calendarModal.start_time=moment(this.calendarModal.start_time).format("HH:mm");
          this.calendarModal.end_time=moment(this.calendarModal.end_time).format("HH:mm");
          this.$refs.modal.show()

        }).catch(err=>{
          this.error('hata ile karşılaşıldı!')
        })
      },
      refreshTable() {
        this.$refs.table.refresh();
      },
      remindAppointment() {
        this.appointmentReminder(this.reminder).then(response => {
          this.success(response.data.message);
          this.setSMSBalance(response.data.balance);
          this.$refs.reminderModal.hide();
        }).catch(error => {
          this.error(error.response.data.message);
        })
      },
      openReminderModal(client) {
        if( client.client ) {
          this.reminder = {
            id: client.id,
            text: `Sayın ${
              client.client.full_name
            }, ${
              this.moment(client.start).format('DD.MM.YY')
            } tarihli; saat ${
              this.moment(client.start).format('HH:mm')
            } prova randevunuzu hatırlatırız.`,
          };
          this.$refs.reminderModal.show();
        }
      },
      deleteAction(id) {
        this.deleteAppointment(id).then(res => {
          this.success(res.data.message);
          this.$refs.table.refresh();
        })
      },
      moment(d) {
        return moment(d);
      },
      resetCalendarModal() {
        this.calendarModal = {
          client: {},
          employee: { label: "Tüm Çalışanlar", value: "all" },
          services: [],
          start_date: null,
          start_time: null,
          end_date: null,
          end_time: null,
          sendSMS: false,
        };
      },
      saveAppointment () {
        this.buttonLoading = true;
        this.createAppointment(this.calendarModal)
          .then(response => {
            this.success(response.data.message)
            this.buttonLoading = false;
            this.loadData();
            this.hideModal()
          }).catch(error => {
          this.error(error.response.data.message)
          this.buttonLoading = false;
        })
      },
      updateAppointment(){
        request.put('appointments/'+this.calendarModal.id,this.calendarModal).then(res=>{
          this.success(res.data.message)
          this.$refs.modal.hide()
          this.$refs.table.refresh()
        }).catch(err=>{
          this.error(err.message)
        })
      },
      hideModal(){
        this.$refs.modal.hide()
      },
      saveService() {
        this.createServiceVSelect(this.serviceModal)
          .then(
            response => {
              this.services.push(response.data);
              this.calendarModal.services.push(response.data);
              this.service = {}
              this.success("Hizmet başarıyla oluşturuldu!");
            }
          );
      },
      resetServiceModal() {
        this.serviceModal = {
          name: "",
          price: ""
        };
      },
      checkService() {
        if (this.service) {
          if (this.service.value === "create_new") {
            this.$refs.createService.show();
          } else {
            this.calendarModal.services.push(this.service)
            this.service = {}
          }
        }
      },
      removeService(key) {
        this.calendarModal.services.splice(key, 1);
      },
      saveClient() {
        const request = {
          ...this.clientModal,
          type: "client"
        };
        this.createClientVSelect(request).then(response => {
          this.clients.push(response.data);
          this.calendarModal.client = response.data;
          this.success("Müşteri başarıyla oluşturuldu!");
        });
      },
      resetClientModal() {
        this.clientModal = {
          full_name: "",
          gsm: "",
          email: ""
        };
      },
      checkClient() {
        if (this.calendarModal.client && this.calendarModal.client.value === "create_new") {
          this.$refs.createClient.show();
        }
      },
      loadData () {
        this.loading = true
        let payloads = {}
        payloads.employee = this.employee
        if (this.getType == 'all') {

          payloads.getType = 'all'
          if (this.company != null)
            payloads.company = this.company
        }
        this.loading = true
        return this.getAppointments(payloads)
          .then(json => json.data)
          .then(response => {

            this.clients = response.clients;
            this.clients.unshift({ label: "Yeni Oluştur", value: "create_new" });

            this.services = response.services;
            this.services.unshift({ label: "Yeni Oluştur", value: "create_new" });

            this.employees = response.employees;
            this.employees.unshift({ label: "Tüm Çalışanlar", value: "all" });

            this.selectEmployees = JSON.parse(JSON.stringify(this.employees)).map(item => {
              return {
                value: item.value,
                text: item.label,
              }
            })

            this.loading = false;

            const items = response.appointments.map(item => {
              return {
                id: item.id,
                title: item.client ? item.client.full_name : 'Üye silinmiş',
                start: item.start_time,
                end: item.end_time,
                client: item.client,
                employee: item.employee,
                product_list: item.product_list,
                services: item.services,
                company: item.company.title,
              }
            });
            return items;
          });
      }
    },
    validations: {
      calendarModal: {
        client: {
          value: { required }
        },
        start_date: { required },
        start_time: { required },
        end_date: { required },
        end_time: { required },
      }
    },
  }
</script>
